import React from 'react'
import ReactDOM from 'react-dom'
import SimpleReactLightbox from 'simple-react-lightbox'

import qs from 'query-string'

import './index.scss'
import App from './App'

let slug = window.location.pathname.split('/').pop()
let productSlug = slug.split('_')[0]
let patternSlug = slug.split('_')[1]
const parsed = qs.parse(window.location.search)
const variantIdOnLoad = parsed.variant
const pdpBundle =  window.location.pathname.includes('pdp-bundle')
// console.log('productSlug, patternSlug, parsed, variantIdOnLoad', productSlug, patternSlug, parsed, variantIdOnLoad)

ReactDOM.render(
    <React.StrictMode>
        <SimpleReactLightbox>
            <App slug={productSlug} patternSlug={patternSlug} variantIdOnLoad={variantIdOnLoad} pdpBundle = {pdpBundle} />
        </SimpleReactLightbox>
    </React.StrictMode>,
    document.getElementById('root')
)
